import Footer from './Footer.js'
export default Footer;
